import React from 'react';
import AddContactInformation from 'pages/components/AddContactInformation';

const ScreeningNeedReferralAddContactInfo = (props) => (
  <AddContactInformation {...props} />
);

export default ScreeningNeedReferralAddContactInfo;
